module.exports = __webpack_public_path__ + "static/media/students2.4ec71afd.png";